import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Highlight, Icon, Tooltip } from '@node-space/ui-components'

const SafeGuardIcon = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="safeguard-icon">
      <Tooltip
        testId="safeguard"
        type="complex"
        position="bottom"
        bodyContent={t('wallets.safeguardTooltip')}
        actionButton={
          <Button
            variant="ghost"
            noPadding
            onClick={() =>
              window.open(process.env.SAFEGUARD_LEARN_MORE_LINK, '_blank', 'noopener,noreferrer')
            }
          >
            {t('wallets.safeguardTooltipSeeHere')}
          </Button>
        }
      >
        <div>
          <Highlight
            variant="emphasis"
            type="success"
            iconElement={<Icon name="ShieldCheck" size="small" />}
          >
            {t('wallets.safeguarded')}
          </Highlight>
        </div>
      </Tooltip>
    </Box>
  )
}

export default SafeGuardIcon
